'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options"];
import { forwardRef } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReferenceInputEnumNone = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      options = []
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const SelectComponent = props.SelectComponent || Select;
  return /*#__PURE__*/_jsx(SelectComponent, Object.assign({}, rest, {
    ref: ref,
    options: options
  }));
});
export default ReferenceInputEnumNone;